import React from "react";
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";

export const CustomNumberFormat = React.forwardRef(function CustomNumberFormat(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
    />
  );
});

CustomNumberFormat.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};
